module.exports = __webpack_public_path__ + "img/lexus.643547ee.png";